module.exports = __webpack_public_path__ + "img/IMG_7492.e65e86df.webp";